import { render } from "./AptTradeView.vue?vue&type=template&id=56a9b3a0&ts=true"
import script from "./AptTradeView.vue?vue&type=script&lang=ts"
export * from "./AptTradeView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__